<script lang="ts">
    import Button from '$lib/components/ui/button/button.svelte';
    import {t} from 'svelte-i18n'
    import {pop} from 'svelte-spa-router'
</script>

<h1>{$t('global.messages.forbidden.title')}</h1>

